import {
  Avatar,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material'
import { compose, head, map, split, take, toUpper } from 'ramda'
import { isNilOrEmpty } from 'ramda-adjunct'
import { Link } from 'react-router-dom'
import { LogoutOutlined } from '@mui/icons-material'
import React, { useState } from 'react'

import { getPagePath } from 'config/routes'
import useIsBelowBreakpoint from 'hooks/useIsBelowBreakpoint'

import { string } from 'prop-types'
import useStyles from './styles'

const MenuProfile = ({ userName }) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const isBelowMd = useIsBelowBreakpoint('md')

  const open = Boolean(anchorEl)

  const createAcronym = fullName => {
    if (!isNilOrEmpty(fullName)) {
      const splitUserName = split(' ', fullName)

      return compose(
        take(2),
        map(word => toUpper(head(word))),
      )(splitUserName)
    }

    return null
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div className={classes.headerControl}>
      <div className={classes.user}>
        {!isBelowMd && (
          <Typography color="black">{userName || 'Utilisateur'}</Typography>
        )}
        <IconButton
          className={classes.iconBtn}
          onClick={event => handleClick(event)}
        >
          <Avatar className={classes.avatar}>{createAcronym(userName)}</Avatar>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          elevation={0}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          className={classes.menu}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem>
            <Link to={getPagePath('logout')} className={classes.link}>
              <ListItemIcon>
                <LogoutOutlined fontSize="small" />
              </ListItemIcon>
              Logout
            </Link>
          </MenuItem>
        </Menu>
      </div>
    </div>
  )
}

MenuProfile.propTypes = {
  userName: string.isRequired,
}

export default MenuProfile
